// All features enabled - COMPLETE version
// System simplified - no more standard/complete switch

export const features = {
  // Frontend Public
  homepage: true,
  services: true,
  donations: true,
  subscriptions: true,
  videoCourses: true,
  quizDRPCIV: true,
  contact: true,
  auth: true,
  gallery: true,
  bookings: true,
  aboutUs: true,
  promoBanner: true,
  downloadableMaterials: false,  // DISABLED - Replaced by chapter theory
  chapterQuizzes: true,

  // Admin Panel
  adminDashboard: true,
  adminUsers: true,
  adminPayments: true,
  adminPlans: true,
  adminVideos: true,
  adminContacts: true,
  adminCategories: true,
  adminPromos: true,
  adminGallery: true,
  adminBookings: true,
  adminDetailedStats: true,
  adminMaterials: false,  // DISABLED - Replaced by chapter theory editing
  adminQuizzes: true,
};

export default features;
